import React from "react";

/**
 * The beta mark, used wherever a not-yet-finished surface is named — the left
 * nav and the page titles. Single appearance on purpose: one component means
 * the mark cannot say the same thing two different ways.
 *
 * The collapsed nav rail draws its own dot instead, because positioning a mark
 * against an icon is layout-specific and does not belong here.
 */
function BetaBadge({ style }) {
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        flex: "0 0 auto",
        height: 17,
        padding: "0 6px",
        borderRadius: 5,
        border: "1px solid rgba(124, 58, 237, 0.35)",
        background: "rgba(124, 58, 237, 0.12)",
        color: "#7C3AED",
        fontSize: 9.5,
        fontWeight: 800,
        letterSpacing: "0.06em",
        textTransform: "uppercase",
        lineHeight: 1,
        whiteSpace: "nowrap",
        ...style,
      }}
    >
      Beta
    </span>
  );
}

export default BetaBadge;
